import { ICandidate } from "../pages/CandidatePage/ICandidate";

export const DEFAULT_CANDIDATE: ICandidate = {
  first_name: "",
  last_name: "",
  ioet_id: "",
  employment_status: "",
};
